module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAAuUlEQVQ4T+XQPQ4BYRSF4feOSRRCSUGitQXFjEKj1VqDWqm0E6OzBIVCZwMieolCyCTEcMQE1fib1m2/7z4555qGXohjGdLMRWfTyD8gsmn2MY6mwI+AdAngbArqNeRWcXB/SnExYaeV3ZYU+Dsg/xMAEYtN7gGsgeIdmGF0EzFpANa6vx3Yh4UkYGKdaTMJUOCPgfZ7QJqD9XEU48+JO6sH1viU4NtTvKzwp4C3xKzybfn4n9jilspXUOVf1hQMBWQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/goodsCheck.png
// module id = fHFq
// module chunks = 2